import React from 'react'
import Header from './components/header/Header'
import Banner from './components/banner/Banner'
import OurEvents from './components/ourevents/OurEvents'
import Members from './components/members/Members'
import FacultyAdvisor from './components/facultyadvisor/FacultyAdvisor'
import FacultySponsor from './components/facultysponsor/FacultySponsor'
import CurrentEvents from './components/currentevents/CurrentEvents'
import Footer from './components/footer/Footer'

const Webpage = () => {

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className='w-full'>
        <Header scrollToSection={scrollToSection} />
        <Banner />
        <OurEvents />
        <Members />
        <FacultyAdvisor />
        <FacultySponsor />
        <CurrentEvents />
        <Footer />
    </div>
  )
}

export default Webpage